import {Link} from 'react-router-dom'
import {FaStar} from 'react-icons/fa'
import {MdLocationOn} from 'react-icons/md'
import {IoBagHandle} from 'react-icons/io5'

import './index.css'

const JobItem = props => {
  const {jobDetails} = props
  const {
    companyLogoUrl,
    employmentType,
    id,
    jobDescription,
    location,
    packagePerAnnum,
    rating,
    title,
  } = jobDetails
  return (
    <Link to={`jobs/${id}`} className="link">
      <li className="job-item">
        <div className="logo-and-title utility-flex">
          <img
            src={companyLogoUrl}
            alt="job details company logo"
            className="company-logo"
          />
          <div className="title-and-rating">
            <h2 className="company-title">{title}</h2>
            <div className="star-and-rating utility-flex">
              <FaStar />
              <p className="rating">{rating}</p>
            </div>
          </div>
        </div>
        <div className="location-employment-type-package-container utility-flex">
          <div className="location-and-employment-type utility-flex">
            <div className="location-logo-and-location utility-flex">
              <MdLocationOn />
              <p className="location">{location}</p>
            </div>
            <div className="job-type-logo-and-job-type utility-flex">
              <IoBagHandle />
              <p className="location">{employmentType}</p>
            </div>
          </div>
          <p className="package">{packagePerAnnum}</p>
        </div>
        <hr className="line" />
        <h2 className="description-heading">Description</h2>
        <p className="description">{jobDescription}</p>
      </li>
    </Link>
  )
}

export default JobItem
